var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react/require-default-props */
import { useMemo, useState } from 'react';
import classNames from 'classnames';
import moment from 'moment';
import { useIntl } from 'react-intl';
import { formatListValue } from '@/shared/components/FormattedListValue';
import PopoverStickOnHover from '@/shared/components/PopoverStickOnHover';
import { CommentIcon, PaperclipIcon } from '@/shared/components/Icons';
import { defaultItemType, getTaskColor, Method, states, taskColors, TaskStatus, TaskType, } from '@/modules/tasks/taskboard/kanban/constants';
import authService, { functionalities, privileges } from '@/shared/services/AuthService';
import taskMessages from '@/modules/tasks/taskMessages';
import { useDataContext } from '@/shared/providers/DataProvider';
import { useGetPlannedTaskRemark } from '@/shared/hooks/task/useGetPlannedTaskRemark';
import { ModalType, useModalContext } from '@/shared/providers/ModalProvider';
import { useGetTaskAttachments } from '@/shared/hooks/task/useGetTaskAttachments';
import { useUpdateTaskStatus } from '@/shared/hooks/task/useUpdateTaskStatus';
import api from '@/shared/api';
import { minutesToTimeSpan } from '@/shared/utils/adminpulse';
import config from '@/config';
import handleHttpError from '@/shared/services/HandleHttpError';
import { useCreateTaskTimeRegistration, } from '@/shared/hooks/task/registration/useCreateTaskTimeRegistration';
import { TaskQueryKey } from '@/shared/hooks/task/queryKey';
import { useQueryClient } from '@tanstack/react-query';
import ToastrService from '@/shared/services/ToastrService';
import appMessages from '@/shared/messages/appMessages';
import EditableDatePicker from '@/shared/components/editable/EditableDatePicker';
import FormattedDateShort from '@/shared/components/FormattedDateShort';
import { useTaskTimerContext } from '@/shared/providers/TaskTimerProvider';
import TaskAttachmentsPopover from '../../TaskAttachmentsPopover';
import { useGetTaskDocumentation } from '@/shared/hooks/task/useGetTaskDocumentation';
import dompurify from 'dompurify';
import TaskIcon from '@/modules/tasks/TaskIcon';
import TaskStatusToggle from '@/modules/tasks/TaskStatusToggle';
import RelationName from '@/shared/components/RelationName';
var sanitizer = dompurify.sanitize;
var stop = function (e) {
    e.stopPropagation();
};
var WeekPlannerElementComponent = function (_a) {
    var _b, _c, _d, _e, _f;
    var element = _a.element, isDragging = _a.isDragging, openTaskDetailModal = _a.openTaskDetailModal, onTasksUpdated = _a.onTasksUpdated, onUpdateExecutionDate = _a.onUpdateExecutionDate;
    var intl = useIntl();
    var defaultCompany = useDataContext().defaultCompany;
    var setShowModalInfo = useModalContext().setShowModalInfo;
    var updateTaskStatus = useUpdateTaskStatus().updateTaskStatus;
    var createTaskTimeRegistration = useCreateTaskTimeRegistration().createTaskTimeRegistration;
    var _g = useTaskTimerContext(), startStopTimer = _g.startStopTimer, isTimerRunningForSubTaskId = _g.isTimerRunningForSubTaskId, processTimeRegistrationResult = _g.processTimeRegistrationResult;
    var queryClient = useQueryClient();
    var _h = useState(false), loadDocumentation = _h[0], setLoadDocumentation = _h[1];
    var _j = useState(false), loadRemark = _j[0], setLoadRemark = _j[1];
    var _k = useState(false), loadAttachments = _k[0], setLoadAttachments = _k[1];
    var _l = useGetPlannedTaskRemark(element.id, (_b = element.taskLevel) !== null && _b !== void 0 ? _b : 1, !!element.scheduleHasRemark, loadRemark), remark = _l.data, loadingRemark = _l.isLoading;
    var _m = useGetTaskDocumentation(element.templateId, loadDocumentation), documentation = _m.data, loadingDocumentation = _m.isLoading;
    var _o = useGetTaskAttachments(element.id, (_c = element.taskLevel) !== null && _c !== void 0 ? _c : 1, loadAttachments), attachments = _o.data, loadingAttachments = _o.isLoading;
    var canUpdateTask = useMemo(function () {
        return authService.hasPermission({
            functionality: functionalities.PlannedTask,
            privilege: privileges.Update,
        });
    }, []);
    var isTimerRunning = useMemo(function () { return isTimerRunningForSubTaskId === element.id; }, [
        element.id,
        isTimerRunningForSubTaskId,
    ]);
    var state = states[element.status];
    var openTimeRegistrationDialog = function () {
        setShowModalInfo({ modalType: ModalType.TimeRegistration, task: element });
    };
    var openMailDialog = function () {
        setShowModalInfo({
            modalType: ModalType.TaskMail,
            task: element,
            onSave: function () { return __awaiter(void 0, void 0, void 0, function () {
                var taskTimeRegistration, timeRegistrationResult;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, updateTaskStatus({
                                id: element.id,
                                status: TaskStatus.Done,
                                isBlocked: !!element.isBlocked,
                                inapplicable: !!element.inapplicable,
                                rejected: !!element.rejected,
                            })];
                        case 1:
                            _a.sent();
                            if (!(defaultCompany.taskTimeRegistrationMethod === Method.AutomaticRegistration)) return [3 /*break*/, 6];
                            if (!(element.defaultDuration && element.defaultDuration > 0)) return [3 /*break*/, 4];
                            taskTimeRegistration = {
                                plannedTaskId: element.id,
                                plannedTaskTemplateId: element.templateId,
                                plannedTaskName: element.name,
                                invoiceStreamId: element.invoiceStreamId,
                                relationId: element.relationId,
                                resourceId: element.resourceId,
                                durationMinutes: String(element.defaultDuration),
                                mainPlannedTaskId: element.parentTaskId,
                                mainTaskTemplateId: element.parentTemplateId,
                                mainPlannedTaskName: element.parentName,
                            };
                            return [4 /*yield*/, createTaskTimeRegistration(taskTimeRegistration)];
                        case 2:
                            timeRegistrationResult = _a.sent();
                            return [4 /*yield*/, processTimeRegistrationResult(timeRegistrationResult)];
                        case 3:
                            _a.sent();
                            return [3 /*break*/, 5];
                        case 4:
                            ToastrService.info(intl.formatMessage(appMessages.msgNoRegistrationMadeDefaultTimeZero));
                            _a.label = 5;
                        case 5: return [3 /*break*/, 7];
                        case 6:
                            if (defaultCompany.taskTimeRegistrationMethod === Method.OpenFormOnDone) {
                                openTimeRegistrationDialog();
                            }
                            _a.label = 7;
                        case 7:
                            queryClient.invalidateQueries({ queryKey: [TaskQueryKey.WeekPlanner] });
                            return [2 /*return*/];
                    }
                });
            }); },
        });
    };
    var onStartStopTimer = function () { return __awaiter(void 0, void 0, void 0, function () {
        var stubMainTask;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    stubMainTask = {
                        id: element.parentTaskId,
                        templateId: element.parentTemplateId,
                        name: element.parentName,
                    };
                    return [4 /*yield*/, startStopTimer(stubMainTask, element)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var onUpdateDeadline = function (deadline) { return __awaiter(void 0, void 0, void 0, function () {
        var formatted, updated, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    formatted = deadline ? moment(deadline).format('YYYY-MM-DD') : '';
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, api.base.put("".concat(config.appUrls.tasks, "/api/plannedTasks/Deadline/").concat(element.id, "/").concat(formatted), null, { params: { taskLevel: element.taskLevel } })];
                case 2:
                    updated = (_a.sent()).data;
                    if (updated === null || updated === void 0 ? void 0 : updated.id) {
                        onTasksUpdated([updated]);
                    }
                    else {
                        queryClient.invalidateQueries({ queryKey: [TaskQueryKey.WeekPlanner] });
                    }
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    handleHttpError(intl)(err_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var getTaskTypeIcon = function () {
        switch (element.type) {
            case TaskType.ActualTask:
                return _jsx("i", { className: "fa fa-user task-type-icon", style: { fontSize: '16px' } });
            case TaskType.DefaultTime:
                return _jsx("i", { className: "fa fa-hourglass task-type-icon" });
            case TaskType.Condition:
                return (_jsx("i", { className: "fa fa-question task-type-icon", title: intl.formatMessage(taskMessages.TimeRegistrationIsNotPossibleTaskTypeCondition) }));
            case TaskType.Mail:
                if (state.status <= 1) {
                    return (_jsx("i", { className: "fa fa-envelope action-icon task-type-icon clickable", onClick: function (e) {
                            stop(e);
                            openMailDialog();
                        }, title: intl.formatMessage(taskMessages.SendMail) }));
                }
                if (state.status === 2) {
                    return (_jsx("a", __assign({ onClick: function (e) {
                            stop(e);
                            openTaskDetailModal(element);
                        }, title: intl.formatMessage(taskMessages.OpenMailHistory) }, { children: _jsx("i", { className: "fa fa-envelope" }) })));
                }
                return null;
            case TaskType.AutomaticMail:
                if (state.status <= 1) {
                    return (_jsxs("span", __assign({ onClick: function (e) {
                            stop(e);
                            openMailDialog();
                        }, title: intl.formatMessage(taskMessages.AutomaticMailTooltip), className: "fa-stack fa-sm action-icon task-type-icon clickable" }, { children: [_jsx("i", { className: "fa fa-calendar fa-stack-2x text-blue" }), _jsx("i", { className: "fa fa-envelope fa-stack-15x ", style: { left: '2px', top: '5px' } })] })));
                }
                if (state.status === 2) {
                    return (_jsx("a", __assign({ onClick: function (e) {
                            stop(e);
                            openTaskDetailModal(element);
                        }, title: intl.formatMessage(taskMessages.OpenMailHistory) }, { children: _jsx("i", { className: "fa fa-envelope" }) })));
                }
                return null;
            default:
                return null;
        }
    };
    var taskColor = getTaskColor(element.status === TaskStatus.Done ? 0 : element.taskColor || 1);
    var remarkPopover = (_jsxs("span", __assign({ id: "popover-trigger-hover-focus" }, { children: [loadingRemark ? _jsx("i", { className: "fa fa-spin fa-spinner" }) : null, (remark === null || remark === void 0 ? void 0 : remark.remark) ? _jsx("span", __assign({ style: { whiteSpace: 'pre-line' } }, { children: remark.remark })) : null, (remark === null || remark === void 0 ? void 0 : remark.remark) && remark.scheduleRemark ? (_jsx("hr", { className: "dark-line", style: { marginTop: '10px', marginBottom: '10px' } })) : null, (remark === null || remark === void 0 ? void 0 : remark.scheduleRemark) ? (_jsx("span", __assign({ style: { whiteSpace: 'pre-line' } }, { children: remark.scheduleRemark }))) : null] })));
    var documentationPopover = (_jsxs("span", __assign({ id: "popover-trigger-hover-focus" }, { children: [loadingDocumentation ? _jsx("i", { className: "fa fa-spin fa-spinner" }) : null, _jsx("div", { 
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML: { __html: sanitizer((documentation === null || documentation === void 0 ? void 0 : documentation.documentation) || '') } })] })));
    var showTimeRegistrationButton = element.type !== TaskType.Condition &&
        (defaultCompany.taskTimeRegistrationMethod !== Method.AutomaticRegistration ||
            (defaultCompany.taskTimeRegistrationMethod === Method.AutomaticRegistration &&
                (state === null || state === void 0 ? void 0 : state.status) === TaskStatus.Done)) &&
        !isTimerRunning;
    var showTimerButton = element.type !== TaskType.Mail &&
        element.type !== TaskType.AutomaticMail &&
        element.type !== TaskType.DefaultTime &&
        (isTimerRunning ||
            ((state === null || state === void 0 ? void 0 : state.status) === TaskStatus.InProgress &&
                defaultCompany.taskTimeRegistrationMethod === Method.AutomaticRegistration));
    var parentLabel = (_d = element.parentName) !== null && _d !== void 0 ? _d : (element.parentTemplateId
        ? formatListValue({
            list: 'tasktemplate',
            id: element.parentTemplateId,
            intl: intl,
            fallback: element.parentTemplateName,
        })
        : null);
    var titleText = (_e = element.name) !== null && _e !== void 0 ? _e : formatListValue({
        list: 'tasktemplate',
        id: element.templateId,
        intl: intl,
        fallback: element.templateName,
    });
    var statusToggleValue = {
        id: element.id,
        status: element.status,
        isBlocked: !!element.isBlocked,
        inapplicable: !!element.inapplicable,
        rejected: !!element.rejected,
        hasAttachments: false,
        hasRemark: false,
        taskLevel: element.taskLevel,
        taskType: element.taskType,
        type: element.type,
    };
    return (_jsx("div", __assign({ className: "week-planner-item-container", id: "task_".concat(element.id) }, { children: _jsxs("div", __assign({ className: "week-planner-item", style: {
                backgroundColor: isDragging
                    ? taskColors.dragging.backgroundColor
                    : taskColor.backgroundColor,
            } }, { children: [_jsx("div", { className: "dskb-gripper", style: {
                        backgroundColor: (_f = taskColor.color) !== null && _f !== void 0 ? _f : defaultItemType.color,
                    } }), _jsxs("div", __assign({ className: "week-planner-item-content" }, { children: [_jsxs("div", __assign({ className: "week-planner-item-header" }, { children: [_jsxs("a", __assign({ id: "element-item-".concat(element.id), role: "button", className: classNames('name-property', 'week-planner-item-title', (element.inapplicable || element.rejected) && 'strike'), onClick: function () { return openTaskDetailModal(element); } }, { children: [_jsx(TaskIcon, { taskLevel: element.taskLevel }), _jsxs("span", __assign({ className: "week-planner-item-title-text" }, { children: [titleText, parentLabel ? _jsxs("span", __assign({ className: "text-muted" }, { children: [" (", parentLabel, ")"] })) : null, !!element.executionDuration && (_jsxs("span", { children: [" (", minutesToTimeSpan(element.executionDuration), ")"] }))] }))] })), _jsx("span", __assign({ onClick: stop, onMouseDown: stop }, { children: _jsx(TaskStatusToggle, { id: "week-planner-status-".concat(element.id), value: statusToggleValue, isMainTask: element.taskLevel !== 1, onTasksUpdated: onTasksUpdated, onOpenDetail: function () { return openTaskDetailModal(element); }, onAddRegistration: openTimeRegistrationDialog, pullRight: true }) }))] })), _jsx(RelationName, { relation: element.relation }), _jsxs("div", __assign({ className: "week-planner-item-dates" }, { children: [element.taskLevel !== 2 && (_jsxs("span", __assign({ className: "week-planner-item-date" }, { children: [_jsx("i", { className: "fa fa-calendar-check-o", title: intl.formatMessage(taskMessages.ExecutionDate) }), _jsx(EditableDatePicker, { value: element.executionDate ? moment.utc(element.executionDate) : null, nullDisplayValue: intl.formatMessage(taskMessages.NoExecutionDate), onChange: function (date) { return onUpdateExecutionDate(element, date); }, readOnly: !canUpdateTask, showTodayButton: true })] }))), _jsxs("span", __assign({ className: "week-planner-item-date" }, { children: [_jsx("i", { className: "fa fa-calendar", title: intl.formatMessage(taskMessages.Deadline) }), element.status !== TaskStatus.Done ? (_jsx(EditableDatePicker, { showClearDate: true, value: element.deadline ? moment.utc(element.deadline) : null, nullDisplayValue: intl.formatMessage(taskMessages.NoDeadline), onChange: function (deadline) { return onUpdateDeadline(deadline); }, readOnly: !canUpdateTask, showTodayButton: true })) : element.deadline ? (_jsx(FormattedDateShort, { value: moment.utc(element.deadline).toDate() })) : (_jsx("span", { children: intl.formatMessage(taskMessages.NoDeadline) }))] })), (state === null || state === void 0 ? void 0 : state.status) === TaskStatus.Done && element.completedDate && (_jsxs("span", __assign({ className: "week-planner-item-completed" }, { children: [_jsx("i", { className: "fa fa-check" }), _jsx("span", { children: intl.formatDate(element.completedDate) })] }))), _jsxs("span", __assign({ className: "week-planner-item-actions", onClick: stop, onMouseDown: stop }, { children: [element.isBlocked && (_jsx("i", { className: "fa fa-minus-circle text-danger blocked-icon", title: intl.formatMessage(taskMessages.Blocked) })), element.hasAttachments && (_jsx(PopoverStickOnHover, __assign({ trigger: ['hover', 'focus'], placement: "top", component: _jsx(TaskAttachmentsPopover, { attachments: attachments, loadingAttachments: loadingAttachments }), shouldUpdatePosition: true, onMouseEnter: function () { return setLoadAttachments(true); }, onClick: function () { return openTaskDetailModal(element); } }, { children: _jsx("span", { children: _jsx(PaperclipIcon, {}) }) }))), (element.hasRemark || element.scheduleHasRemark) && (_jsx(PopoverStickOnHover, __assign({ trigger: ['hover', 'focus'], placement: "top", component: remarkPopover, shouldUpdatePosition: true, onMouseEnter: function () { return setLoadRemark(true); }, onClick: function () { return openTaskDetailModal(element); } }, { children: _jsx("span", { children: _jsx(CommentIcon, {}) }) }))), showTimeRegistrationButton && (_jsx("a", __assign({ onClick: function (e) {
                                                stop(e);
                                                openTimeRegistrationDialog();
                                            } }, { children: _jsx("i", { className: "fa fa-clock-o", title: intl.formatMessage(taskMessages.CreateTimeRegistration) }) }))), showTimerButton && (_jsx("a", __assign({ onClick: function (e) {
                                                stop(e);
                                                onStartStopTimer();
                                            } }, { children: isTimerRunning ? (_jsx("i", { className: "fa fa-pause-circle", title: intl.formatMessage(taskMessages.PauseTimer) })) : (_jsx("i", { className: "fa fa-play-circle", title: intl.formatMessage(taskMessages.StartTimer) })) }))), element.hasDocumentation && (_jsx(PopoverStickOnHover, __assign({ trigger: ['hover', 'focus'], placement: (state === null || state === void 0 ? void 0 : state.status) === TaskStatus.Done ? 'left' : 'bottom', component: documentationPopover, shouldUpdatePosition: true, onMouseEnter: function () { return setLoadDocumentation(true); }, onClick: function () { return openTaskDetailModal(element); } }, { children: _jsx("i", { className: "fa fa-book" }) }))), getTaskTypeIcon()] }))] }))] }))] })) }), element.id));
};
export default WeekPlannerElementComponent;
